import React, { useEffect, useContext } from 'react';
import _ from 'lodash';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import { makeStyles } from '@material-ui/styles';
import { Avatar, Drawer, Hidden, Paper, Typography } from '@material-ui/core';
import LogoutIcon from '@material-ui/icons/Input';
import { AuthContext } from 'context/AuthContext';

import initials from 'utils/initials';
import { SideBar as SideBarNav } from 'components';
import SideBarListItem from 'components/SideBar/components/SideBarList/SideBarListItem';
import { useSettings } from 'hooks';
import { AccountCircle } from 'mdi-material-ui';

import n from './sidebarItems';
import { Roles } from 'utils/authHelpers';

const useStyles = makeStyles((theme) => ({
  root: {
    maxHeight: '100%',
    overflowY: 'auto',
    backgroundColor: 'rgba(255,255,255,0.6)',
  },
  profile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'fixed',
    bottom: theme.spacing(2),
    minHeight: 'fit-content',
  },
  avatar: {
    width: 60,
    height: 60,
  },
  name: {
    marginTop: theme.spacing(1),
  },
  divider: {
    marginTop: theme.spacing(2),
  },
  navigation: {
    marginTop: theme.spacing(2),
  },
}));

const SideBar = (props) => {
  const { openMobile, onMobileClose, className, ...rest } = props;
  const { logout } = useContext(AuthContext);
  const location = useLocation();
  const { currentUserRoles } = useSettings();

  const classes = useStyles();

  const user = {
    display_name: '',
    teamName: 'Atomic',
  };

  const adminSidebarItem = {
    title: 'admin',
    href: '/admin',
    icon: AccountCircle,
  };

  let sidebar = {};
  _.forEach(n, (sidebarItems) => {
    sidebar = sidebarItems;
    if (_.includes(currentUserRoles, Roles.Super) || _.includes(currentUserRoles, Roles.Admin)) {
      if (!_.some(sidebar.pages, adminSidebarItem)) {
        sidebar.pages.push(adminSidebarItem);
      }
    } else {
      const newPages = _.filter(sidebar.pages, (page) => {
        return page.href !== '/admin';
      });
      sidebar.pages = newPages;
    }
  });
  const navigationConfig = [sidebar];

  useEffect(() => {
    if (openMobile) {
        onMobileClose && onMobileClose(); // eslint-disable-line
    }
  }, [location.pathname]);

  const getPages = (pages) => {
    const p = [];
    _.forEach(pages, (page) => {
      p.push(page);
    });
    return p;
  };

  const children = (
    <div>
      <div className={classes.profile}>
        {user && user.profile && (
          <>
            <Avatar className={classes.avatar} src={user.profile.picture}>
              {initials(user.display_name || '')}
            </Avatar>
            <Typography className={classes.name} variant="h4">
              {user.display_name}
            </Typography>
            <Typography variant="body2">{user && user.teamName}</Typography>
          </>
        )}
      </div>
      <nav className={classes.navigation}>
        {navigationConfig.map((list) => (
          <SideBarNav
            component="div"
            key={list.title}
            pages={getPages(list.pages)}
            title={list.title}
            signOut={<SideBarListItem onClick={logout} icon={LogoutIcon} title="signout" />}
          />
        ))}
      </nav>
    </div>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer anchor="left" onClose={onMobileClose} open={openMobile} variant="temporary">
          <div {...rest} className={clsx(classes.root, className)}>
            {children}
          </div>
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Paper {...rest} className={clsx(classes.root, className)} elevation={1} square>
          {children}
        </Paper>
      </Hidden>
    </>
  );
};

SideBar.propTypes = {
  className: PropTypes.string,
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};

SideBar.defaultProps = {
  className: undefined,
  onMobileClose: () => {},
  openMobile: true,
};

export default SideBar;
